module.exports = __webpack_public_path__ + "img/自由动画.ffff6bd8.png";